import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Card from '@components/ui/Card'
import Button from '@components/ui/Button'
import Loading from '@components/ui/Loading'
import { useAPI } from '@hooks/useAPI'
import { getActivities } from '@services/api/activity'

const LatestNews = () => {
  const { t, i18n } = useTranslation()
  const { data: latestNews, loading, error } = useAPI(() => getActivities({ page: 1, pageSize: 2 }), [i18n.language])

  if (loading) {
    return (
      <section className="py-10">
        <div className="container section-padding">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-xl font-bold text-gray-900">
              {t('home.activities.title', '最新活动')}
            </h2>
            <Link 
              to="/activities"
              className="text-blue-600 hover:text-blue-700 font-medium whitespace-nowrap"
            >
              {t('home.activities.viewAll', '查看全部')}
            </Link>
          </div>
          <div className="flex justify-center">
            <Loading />
          </div>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section className="py-10">
        <div className="container section-padding">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-xl font-bold text-gray-900">
              {t('home.activities.title', '最新活动')}
            </h2>
            <Link 
              to="/activities"
              className="text-blue-600 hover:text-blue-700 font-medium whitespace-nowrap"
            >
              {t('home.activities.viewAll', '查看全部')}
            </Link>
          </div>
          <div className="text-center text-red-600">
            <p>{t('home.activities.loadError', '加载失败')}: {error}</p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="py-10">
      <div className="container section-padding">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl font-bold text-blue-600">
              {t('home.activities.title', '最新活动')}
            </h2>
            <Link 
              to="/activities"
              className="bg-blue-600 text-white hover:bg-blue-700 font-medium whitespace-nowrap px-4 py-2 rounded-md"
            >
              {t('home.activities.viewAll', '查看全部')}
            </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {(() => {
            // 检查数据结构，可能是直接数组或包含在 records 字段中
            const newsArray = Array.isArray(latestNews) ? latestNews : 
                             latestNews?.records ? latestNews.records : 
                             [];
            
            if (newsArray.length === 0) {
              return (
                <div className="col-span-full text-center text-gray-500 py-10">
                  {t('home.activities.noData', '暂无活动数据')}
                </div>
              );
            }
            
            return newsArray.map((activity) => (
              <Link 
                key={activity.activityId} 
                to={`/activities/${activity.activityId}`}
                className="block h-full"
              >
                <Card className="h-full border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div className="p-4">
                    <h3 className="text-xl font-semibold text-blue-600 mb-3">
                      {activity.title}
                    </h3>
                    
                    <p className="text-gray-600 text-base mb-0">
                      {activity.content ? activity.content.replace(/<[^>]*>/g, '').substring(0, 150) + '...' : t('common.noContent')}
                    </p>
                  </div>
                </Card>
              </Link>
            ));
          })()}
        </div>
      </div>
    </section>
  )
}

export default LatestNews 
